import {
    singleContentPageBlockFactory,
    singleContentPageBlockZodSchema,
} from "@@/shared/pages/page-blocks/content/single-content-block/single-content.page-block";
import {
    footerPageBlockFactory,
    footerPageBlockZodSchema,
} from "@@/shared/pages/page-blocks/footers/footer.page-block";
import {
    headerPageBlockFactory_V2,
    headerPageBlockZodSchema_V2,
} from "@@/shared/pages/page-blocks/headers/header-v2/header.page-block.v2";
import { z } from "zod";
import {
    contentAutoPageBlockFactory,
    contentAutoPageBlockZodSchema,
} from "./content/content-auto-block/content-auto.page-block";
import {
    headerPageBlockFactory_V1,
    headerPageBlockZodSchema_V1,
} from "./headers/header-v1/header.page-block.v1";
import {
    posterPageBlockFactory,
    posterPageBlockZodSchema,
} from "./posters/poster.page-block";
import {
    spacerPageBlockFactory,
    spacerPageBlockZodSchema,
} from "./spacers/spacer.page-block";

const pageBlockZodSchema = z.discriminatedUnion("type", [
    contentAutoPageBlockZodSchema,
    headerPageBlockZodSchema_V1,
    headerPageBlockZodSchema_V2,
    posterPageBlockZodSchema,
    footerPageBlockZodSchema,
    spacerPageBlockZodSchema,
    singleContentPageBlockZodSchema,
]);

type PageBlock = z.infer<typeof pageBlockZodSchema>;
type PageBlockType = PageBlock["type"];

const pageBlockFactory = {
    CONTENT_AUTO_PAGE_BLOCK: contentAutoPageBlockFactory,
    FOOTER_PAGE_BLOCK: footerPageBlockFactory,
    HEADER_PAGE_BLOCK: headerPageBlockFactory_V1,
    HEADER_PAGE_BLOCK_V2: headerPageBlockFactory_V2,
    POSTER_PAGE_BLOCK: posterPageBlockFactory,
    SPACER_PAGE_BLOCK: spacerPageBlockFactory,
    SINGLE_CONTENT_PAGE_BLOCK: singleContentPageBlockFactory,
};

export { pageBlockFactory, pageBlockZodSchema };
export type { PageBlock, PageBlockType };
